import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createBankAccountSaga } from "src/store/bankaccounts/saga";
import * as Yup from "yup";

const BankAccountCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("BankAccount.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          BankName: "",
          AccountNumber: "",
          Iban: "",
          OwnerName: "",
        }}
        onSubmit={(values) => {
          dispatch(
            createBankAccountSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          OwnerName: Yup.string().required(t("Validation.Required").toString()),
          Iban: Yup.string().required(t("Validation.Required").toString()),
          AccountNumber: Yup.string().required(
            t("Validation.Required").toString()
          ),
          BankName: Yup.string().required(t("Validation.Required").toString()),
        })}
        inputs={[
          {
            field: "OwnerName",
            label: t("BankAccount.OwnerName").toString(),
          },
          {
            field: "BankName",
            label: t("BankAccount.BankName").toString(),
          },
          {
            field: "AccountNumber",
            label: t("BankAccount.AccountNumber").toString(),
          },
          {
            field: "Iban",
            label: t("BankAccount.Iban").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default BankAccountCreateForm;
